const formatTagPost = (tagPost) => ({
  objectId: tagPost.id,
  post: { objectId: tagPost.post },
  tag: { objectId: tagPost.tag },
  createdAt: tagPost.createdAt,
  updatedAt: tagPost.updatedAt,
});

export default formatTagPost;
